module.exports = __webpack_public_path__ + "static/media/productos_cacahuate_blanequeado_entero.87a6c27b.jpg";